/*
https://stackblitz.com/edit/matmenu-with-checkboxes-demo?file=src%2Fapp%2Fmatmenu-with-checkboxes.ts
*/
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren, ViewEncapsulation} from '@angular/core';

import { MatButton, MatButtonModule } from '@angular/material/button';
import {MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

/**
 * @title Basic menu
 */
 @Component({
  selector: 'so-menu-with-checkboxes',
  templateUrl: 'so-menu-with-checkboxes.html',
  styleUrls: ['so-menu-with-checkboxes.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [ 
    CommonModule,
    MatButtonModule,
    MatCheckboxModule,
    MatMenuModule,
    MatInputModule,   
    MatIconModule,
    MatTooltipModule,
    FormsModule
  ]
})
export class SoMenuWithCheckboxes implements OnInit {
  @Input() options:  MenuCheckBoxOptions[] = [];
  @Input() buttonText: string = 'Select an Option';
  @Input() buttonColor: string = 'primary';
  @Input() menuClass: string = '';
  
  
  @Output() changeEvent = new EventEmitter<MenuCheckBoxOptions[]>();
  
  @ViewChild('matMenuTrigger', { read: MatMenuTrigger })
  private matMenuTriggerRef: MatMenuTrigger;
  @ViewChild('matMenuTrigger', { read: MatButton })
  private matButtonRef: MatButton;
  @ViewChildren('menuItems')
  private menuItemsRef: QueryList<MatCheckbox>;

  public triggerButtonText = 'Select an Option';


  private selectedOptions:  MenuCheckBoxOptions[] = [];
  //public formattedSelectedOptions: string;

  public onMenuOpened() {
    this.setFocusOnFirstItem();
    this.triggerButtonText = 'Close menu';
    //this.formattedSelectedOptions = '';
  }

  public onMenuClosed() {   
    this.matButtonRef.focus();
    this.triggerButtonText = this.buttonText;

    //this.formattedSelectedOptions =
    //  (this.selectedOptions.length === 0
    //    ? 'No options selected'
    //   : 'You selected ' + this.selectedOptions.map(opt => opt.title).join(', ')) + '.';

    this.changeEvent.emit(this.selectedOptions);
  }

  
  ngOnInit(): void {
    this.triggerButtonText = this.buttonText;
    this.selectedOptions = this.options.filter(menuitem => menuitem.activated);
  }
  public onMenuKeyDown(event: KeyboardEvent, index: number) {
    switch (event.key) {
      case 'ArrowUp':
        if (index > 0) {
          this.setCheckboxFocus(index - 1);
        } else {
          this.menuItemsRef.last.focus();
        }
        break;
      case 'ArrowDown':
        if (index !== this.menuItemsRef.length - 1) {
          this.setCheckboxFocus(index + 1);
        } else {
          this.setFocusOnFirstItem();
        }
        break;
       case 'Enter':
        event.preventDefault();
        this.options[index].activated
          = !this.options[index].activated;
        this.onOptionSelect();
        setTimeout(() => this.matMenuTriggerRef.closeMenu(), 200);
        break; 
    }
  }

  public onOptionSelect() {
    this.selectedOptions = this.options
      .filter(menuitem => menuitem.activated);
      //Add this if we want to return just the key of the table.
      //.map(menuitem => menuitem.title);
  }

  private setFocusOnFirstItem(): void {
    const firstCheckbox = this.menuItemsRef.first;
    firstCheckbox.focus();
    firstCheckbox._elementRef
      .nativeElement.classList.add('cdk-keyboard-focused');
  }

  private setCheckboxFocus(index: number) {
    const checkBox = this.menuItemsRef.get(index);
    if (checkBox) {
      checkBox.focus();
    }
  }

  public displayToolTip() {
    let selOpts = this.options.filter(menuitem => menuitem.activated);
    return (selOpts.length === 0
      ? 'No options selected'
      : 'Selection: ' + selOpts.map(opt => opt.title).join(', ')) + '.';

  }
}

export type MenuCheckBoxOptions = {
  title : string;
  activated : boolean;
  value : string;
}